import { partAnswerKey } from "./assessmentKeys";
import { withDisplayNumbers } from "./questionNumbers";

/** Apply a loadAssessment API response into assessment page state. */
export function hydrateAssessmentFromResponse(
  res,
  { assessmentTrack = "full", onLiteCompleted, onFullCompleted } = {}
) {
  const qs = res?.data?.survey_questions || [];
  const loadedTrack = res?.data?.assessment_track || assessmentTrack;
  const status = res?.data?.user_data?.status;

  if (status === "Completed" && loadedTrack === "full") {
    onFullCompleted?.();
    return { earlyExit: true };
  }
  if (status === "LiteCompleted" && loadedTrack === "lite") {
    onLiteCompleted?.();
    return { earlyExit: true };
  }

  let currentStep = 1;
  if (loadedTrack !== "lite") {
    const incomplete = qs.find((s) => s.is_completed === "N");
    if (incomplete?.step) currentStep = incomplete.step;
  }

  const answers = {};
  qs.forEach((step) => {
    step.questions?.forEach((q) => {
      q.parts?.forEach((p) => {
        const key = partAnswerKey(q, p);
        if (p.answer) answers[key] = p.answer;
      });
    });
  });

  return {
    earlyExit: false,
    steps: withDisplayNumbers(qs),
    userData: res?.data?.user_data ?? null,
    track: loadedTrack,
    liteQuestionIds: res?.data?.lite_question_ids || [],
    currentStep,
    answers,
  };
}
